var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useMemo } from "react";
import classnames from "classnames";
import { ImagePicker, Toast, FormField } from "../index";
import "./style/index.less";
const ImagePickerFormItem = ({ label = "附件", itemName = "files", form, limit = 8, required = false, rules = [], fieldOptions = {}, imagePickerClick, uploadAllFile, }) => {
    const { getFieldProps, getFieldValue, getFieldError, setFieldsValue } = form;
    const imagePickerChange = (files) => __awaiter(this, void 0, void 0, function* () {
        try {
            let _files = files.slice();
            if (files.length >= limit) {
                if (files.length > limit) {
                    Toast.info(`最多上传${limit}张图片`);
                }
                _files = files.slice(0, limit);
            }
            const _res = (yield uploadAllFile(_files));
            const res = _res.map((item, index) => Object.assign(item, files[index], {
                ossKey: `${item.taskcenterUrl}`,
                uri: `${item.taskcenterUrl}`,
            }));
            setFieldsValue({
                [itemName]: res,
            });
        }
        catch (error) { }
    });
    const fieldError = useMemo(() => {
        const errors = getFieldError(itemName);
        if (errors && errors.length > 0) {
            return errors.join(",");
        }
        return null;
    }, [itemName, getFieldError(itemName)]);
    const imagePickerChangeClick = (index, files) => {
        if (imagePickerClick) {
            imagePickerClick(index, files);
        }
    };
    return (<FormField form={form} extraItem={<div className={classnames("ppx-image-picker")}>
          <div className={classnames("remark-title", { required })}>
            {label}
          </div>
          <div className={classnames("remark")}>
            <ImagePicker {...getFieldProps(itemName, Object.assign({ valuePropName: "files", rules: [
            {
                required,
                message: `请选择${label}`,
            },
            ...rules,
        ] }, fieldOptions))} accept="image/*" onChange={imagePickerChange} onImageClick={imagePickerChangeClick} selectable={limit >
        ((getFieldValue(itemName) && getFieldValue(itemName).length) ||
            0)} multiple/>
            {fieldError && (<div className={classnames("error")}>{fieldError}</div>)}
          </div>
        </div>}/>);
};
export default ImagePickerFormItem;
